import { render } from "./SelectLang.vue?vue&type=template&id=f28a3260&scoped=true"
import script from "./SelectLang.vue?vue&type=script&lang=js"
export * from "./SelectLang.vue?vue&type=script&lang=js"

import "./SelectLang.vue?vue&type=style&index=0&id=f28a3260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28a3260"]])

export default __exports__